import timeParse from 'date-fns/parse'
import isSameDay from 'date-fns/is_same_day'

const getTheDayIndex = (data, theDay) => {
  const dateObjectArray = data.map(o => timeParse(o.reportDate))
  const theDayObject = timeParse(theDay)
  const theDayIndex = dateObjectArray.findIndex(o => isSameDay(o, theDayObject))
  if (theDayIndex > -1) {
    return theDayIndex
  } else {
    return 'nothing'
  }
}

export default getTheDayIndex
